import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca8859b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[13px] tw-text-[#231F20] tw-font-medium tw-whitespace-nowrap"
}
const _hoisted_2 = { class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap" }
const _hoisted_3 = { class: "tw-text-[13px] tw-text-[#231F20] tw-whitespace-nowrap" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "tw-flex tw-gap-[10px]" }

import { getComponentUiText } from "@/utils/utilities";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import { computed, ref, watch } from "vue";
import { IChecklistHistoryReportChecklistDetail } from "@/interfaces/shares";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import TextAreaRoadmap from "./textAreaRoadmap.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'achievementsAndProgressTable',
  props: {
  data: {
    type: Array as () => IChecklistHistoryReportChecklistDetail[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  isShowEdit: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  columns: {
    type: Array,
    required: false,
    default: () => ["date", "action", "scoreImpact", "notes"],
  },
},
  emits: ["edit-notes", "on-form-invalid"],
  setup(__props, { emit: emits }) {

const props = __props;




const columnsTableFields = computed<CustomTableColumn[]>(() => {
  return [
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-date-header-title-1",
      ),
      value: "date",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-medium",
      sortable: false,
      sortDefault: false,
    },
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-action-header-title-1",
      ),
      value: "action",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal",
    },
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-score-impact-header-title-1",
      ),
      value: "scoreImpact",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal",
    },
    {
      text: getComponentUiText(
        "app-report-achievements-and-progress-table-notes-header-title-1",
      ),
      value: "notes",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-w-[58%]",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[58%]",
    },
  ].filter((item) => props.columns.includes(item.value));
});

const itemInvalids: any = ref([]);
const updateNotes = (value: string, checklistId) => {
  const item = props.data.find((item: any) => item.checklistId === checklistId);
  if (!item) return;
  const idxInvalid = itemInvalids.value.findIndex(
    (item: any) => item === checklistId,
  );
  if (value && idxInvalid >= 0) {
    itemInvalids.value.splice(idxInvalid, 1);
  } else if (!value && idxInvalid === -1) {
    itemInvalids.value.push(checklistId);
  }
};

watch(
  () => itemInvalids.value,
  (newVal) => {
    if (itemInvalids.value.length > 0) {
      emits("on-form-invalid", true);
    } else {
      emits("on-form-invalid", false);
    }
  },
  { deep: true },
);
const formatDate = (date: string) => {
  return convertUTCTimeToLocalTime(date);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTable, {
    columns: columnsTableFields.value,
    data: __props.data,
    "is-loading": __props.isLoading,
    "show-checkbox-row": false,
    "sort-direction": 'asc',
    "skeleton-row-number": 1,
    "custom-class": 'table-share-profile-progress !tw-shadow-none',
    "header-wrapper-class": 'tw-py-[20px] tw-px-[25px]'
  }, {
    "cell(date)": _withCtx((value) => [
      (value.item.checklistHistoryDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formatDate(value.item.checklistHistoryDate)), 1))
        : _createCommentVNode("", true)
    ]),
    "cell(action)": _withCtx((value) => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(value.item.checklistHistoryName), 1)
    ]),
    "cell(scoreImpact)": _withCtx((value) => [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(parseFloat(value.item.checklistHistoryScore)) + "% ", 1),
        (value.idx !== __props.data.length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createTextVNode("("),
              _createElementVNode("span", {
                class: _normalizeClass(`${
              value.item.checklistHistoryImprovementScore > 0
                ? 'tw-text-[#01893d]'
                : 'tw-text-[#F7553c]'
            }`)
              }, _toDisplayString((value.item.checklistHistoryImprovementScore > 0 ? "+" : "") +
              value.item.checklistHistoryImprovementScore +
              "%"), 3),
              _createTextVNode(") ")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell(notes)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(TextAreaRoadmap, {
          key: `roadmap-how-${value.item.checklistId}`,
          "is-edit-status": __props.isShowEdit,
          item: value.item,
          "key-field": 'checklistHistoryNotes',
          "item-invalids": itemInvalids.value,
          onEditNotes: 
            (text) => updateNotes(text, value.item.checklistId)
          ,
          onUpdateNotes: 
            (text) => {
              value.item.checklistHistoryNotes = text;
            }
          
        }, null, 8, ["is-edit-status", "item", "item-invalids", "onEditNotes", "onUpdateNotes"]))
      ])
    ]),
    _: 1
  }, 8, ["columns", "data", "is-loading"]))
}
}

})